import moment from 'moment-timezone'
import { BRAZIL_TIMEZONE } from './constants'
import { BANK_HOLYDAY_DATES } from './general'

export const isWeekendInBrazil = (date: Date): boolean => {
  const dayOfTheWeek = moment.tz(date, BRAZIL_TIMEZONE).day()
  return (dayOfTheWeek === 0) || (dayOfTheWeek === 6)
}

export const isSameDayInBrazil = (firstDate: Date, secondDate: Date): boolean => {
  const firstDateInBrazil = moment.tz(firstDate, BRAZIL_TIMEZONE)
  const secondDateInBrazil = moment.tz(secondDate, BRAZIL_TIMEZONE)

  return (
    (firstDateInBrazil.date() === secondDateInBrazil.date()) &&
    (firstDateInBrazil.month() === secondDateInBrazil.month()) &&
    (firstDateInBrazil.year() === secondDateInBrazil.year())
  )
}

export const isBankWorkdayInBrazil = (date: Date): boolean => {
  return !isBankHolidayInBrazil(date) && !isWeekendInBrazil(date)
}

export const isBankHolidayInBrazil = (date: Date): boolean => {
  return !!BANK_HOLYDAY_DATES.find(bankHoliday => isSameDayInBrazil(bankHoliday, date))
}

export const isSameOrBefore = (firstDate: Date, secondDate: Date): boolean => {
  const startMoment = moment(firstDate)
  const endMoment = moment(secondDate)

  return startMoment.isSameOrBefore(endMoment)
}

export const isBeforeDate = (firstDate: Date, secondDate: Date): boolean => {
  const startMoment = moment(firstDate)
  const endMoment = moment(secondDate)

  return startMoment.isBefore(endMoment)
}

export const isAfterDate = (firstDate: Date, secondDate: Date): boolean => {
  const startMoment = moment(firstDate)
  const endMoment = moment(secondDate)

  return startMoment.isAfter(endMoment)
}

export const isSameOrAfterDate = (firstDate: Date, secondDate: Date): boolean => {
  return moment(firstDate).isSameOrAfter(secondDate)
}

export const checkIfDayIsAfter = (source: Date | string, target: Date | string): boolean => {
  const sourceInBrazil = moment.tz(source, BRAZIL_TIMEZONE).format('YYYY-MM-DD')
  const targetInBrazil = moment.tz(target, BRAZIL_TIMEZONE).format('YYYY-MM-DD')

  return sourceInBrazil > targetInBrazil
}

export const isValidDate = (date: string, format: string = 'DD/MM/YYYY'): boolean => {
  return moment(date, format).isValid()
}
